export default __webpack_public_path__ + "static/media/ico_checkout_cart.0b738298.svg";